/* ==========================================================================
   INFO PANELS - close the others when one opens

   Only behaviour the markup cannot do on its own. <details name="..."> would
   give exclusive panels natively, but Safari only shipped it in 17.2 and this
   store still serves older iOS, so it is done here instead - and only when the
   section asks for it.

   Nothing else is scripted: opening, closing, keyboard and screen-reader
   behaviour are all <details>/<summary>, so the panels still work with
   JavaScript off.
   ========================================================================== */

(function () {
  function wire(root) {
    if (root.dataset.stkiWired === '1') return;
    root.dataset.stkiWired = '1';
    if (root.dataset.stkiExclusive !== 'true') return;

    root.addEventListener('toggle', function (event) {
      var panel = event.target;
      if (!panel.open || !panel.classList.contains('stki__panel')) return;
      var others = root.querySelectorAll('.stki__panel[open]');
      for (var i = 0; i < others.length; i++) {
        if (others[i] !== panel) others[i].open = false;
      }
    }, true);
  }

  function init() {
    var roots = document.querySelectorAll('[data-stki]');
    for (var i = 0; i < roots.length; i++) wire(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* ==========================================================================
   ASK A QUESTION - reopen the row when there is something to read

   Every panel and question is collapsed on load, which is right: the card is a
   list to scan, not a wall to wade through. The one exception is a form that
   has just been posted - Shopify returns to the page with a success or an
   error inside the row, and a closed row would hide it, so the row that holds
   a message opens itself.
   ========================================================================== */

(function () {
  function open_results() {
    var flags = document.querySelectorAll('.stkc__ok, .stkc__err');
    for (var i = 0; i < flags.length; i++) {
      var row = flags[i].closest('details');
      if (row) row.open = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', open_results);
  } else {
    open_results();
  }
})();

/* ==========================================================================
   IMAGE-COLUMN CARDS ON MOBILE

   Below 990px the product goes single-column and the gallery renders first,
   so a card placed in the image column would sit ABOVE the title, price and
   buy button - the opposite of what a card is for. On a narrow screen the
   cards are moved after the info column; back to 990px and up they return to
   the gallery's column, where each one sits directly under the images.

   Done by moving the node rather than CSS order, because the cards live
   inside the gallery's wrapper and order cannot reach across that boundary
   without display:contents, which would strip the wrapper's own styling.
   ========================================================================== */

(function () {
  // Anything up to 1024px wide is a phone for this purpose, whichever way it is
  // held (Thomas, 6 Sep: portrait iPads first, then "the sections look lop
  // sided on both phone and ipad when oriented landscape"): stk-pdp.css makes
  // the product single-column up to 1024px, so the cards move with it.
  var mq = window.matchMedia('(max-width: 1024px)');

  function place() {
    var col = document.querySelector('.stkc__col--media');
    if (!col) return;
    var mediaWrap = document.querySelector('.product__media-wrapper');
    var infoWrap = document.querySelector('.product__info-wrapper');
    if (!mediaWrap || !infoWrap) return;

    if (mq.matches) {
      if (col.parentElement !== infoWrap.parentElement) {
        infoWrap.insertAdjacentElement('afterend', col);
        col.classList.add('stkc__col--below');
      }
    } else if (col.parentElement !== mediaWrap) {
      mediaWrap.appendChild(col);
      col.classList.remove('stkc__col--below');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  if (mq.addEventListener) mq.addEventListener('change', place); else mq.addListener(place);
  document.addEventListener('shopify:section:load', place);
})();
